module.exports = __webpack_public_path__ + "img/banner.715899f9.jpeg";